exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.loader[data-v-37c53c7c] {\n  text-align: center;\n  margin: 30px;\n}\nbutton[data-v-37c53c7c] {\n  border: none;\n}\n.theword[data-v-37c53c7c] {\n  position: absolute;\n  z-index: -1;\n}\n", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Game-new/game-page.vue"],"names":[],"mappings":";AACA;EACE,mBAAmB;EACnB,aAAa;CACd;AACD;EACE,aAAa;CACd;AACD;EACE,mBAAmB;EACnB,YAAY;CACb","file":"game-page.vue","sourcesContent":["\n.loader[data-v-37c53c7c] {\n  text-align: center;\n  margin: 30px;\n}\nbutton[data-v-37c53c7c] {\n  border: none;\n}\n.theword[data-v-37c53c7c] {\n  position: absolute;\n  z-index: -1;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-37c53c7c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Game-new/game-page.vue
// module id = 388
// module chunks = 1 2